<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrKontrolIsbirlikci from "@/models/StrKontrolIsbirlikci";
import IsBirlikciler from "./IsBirlikci.vue";
import AddEdit from "./AddEdit.vue";

export default {
  mixins: [Api, Sabit, StrKontrolIsbirlikci],
  page: {
    title: "İş Birliği Yapılan Birimler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    IsBirlikciler,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("StrKontrolIsbirlikci.Title"),
      items: [
        {
          text: this.$t("StrKontrolIsbirlikci.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrKontrolIsbirlikci.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrKontrolIsbirlikci.Title"),
          active: true,
        },
      ],
      BirimTipleri: [],
      AltTabloVerileri: [],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      TanimId: "",
      siralama:"&Asc=Kod",
    };
  },

  methods: {
    Get() {

      let Filter="";

      if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }
    

      this.ActionsFilterGet({ Service: "StrKontrolTanim", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    IsBirlikciAddEdit(Islem, TanimId) {
      if (Islem == "Add") {
        let Filter = "&TanimId=" + TanimId;

        this.ActionsFilterGet({
          Service: "StrKontrolIsbirlikci",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          if (res.TotalCount != 0) {
            this.AddEdit = "Edit";
            this.DataUpdate = res.Data[0];
            this.$bvModal.show("StrKontrolIsbirlikci");
          } else {
            this.AddEdit = "Add";
            const Bellek = this.StrKontrolIsbirlikciData;
            this.DataUpdate = Bellek;
            this.TanimId = TanimId;
            this.$bvModal.show("StrKontrolIsbirlikci");
          }
        });
      } else {
        this.AddEdit = "Edit";
        this.DataUpdate = TanimId;
        this.$bvModal.show("StrKontrolIsbirlikci");
      }
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped table-bordered mb-0">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">
                        {{ $t("StrKontrolIsbirlikci.Table.UstDonemAciklama") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=UstDonemAciklama'" @click="siralama='&Asc=UstDonemAciklama', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=UstDonemAciklama'" @click="siralama='&Desc=UstDonemAciklama', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                      </th>
                      <th scope="col">
                        {{ $t("StrKontrolIsbirlikci.Table.StandartKodNo") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=StandartKodNo'" @click="siralama='&Asc=StandartKodNo', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=StandartKodNo'" @click="siralama='&Desc=StandartKodNo', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                      </th>
                      <th scope="col">
                        {{ $t("StrKontrolIsbirlikci.Table.StandartGenelSarti") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=StandartGenelSarti'" @click="siralama='&Asc=StandartGenelSarti', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=StandartGenelSarti'" @click="siralama='&Desc=StandartGenelSarti', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                      </th>
                      <th scope="col">
                        {{ $t("StrKontrolIsbirlikci.Table.Kod") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Kod'" @click="siralama='&Asc=Kod', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Kod'" @click="siralama='&Desc=Kod', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                      </th>
                      <th scope="col">
                        {{ $t("StrKontrolIsbirlikci.Table.Eylem") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Eylem'" @click="siralama='&Asc=Eylem', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Eylem'" @click="siralama='&Desc=Eylem', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                      </th>
                      <th scope="col" style="width: 85px; text-align: center; vertical-align: middle;">
                        {{ $t("StrKontrolIsbirlikci.Table.Islem") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
                    <tr  >
                      <th scope="row" class="custom-accordion">
                        <a
                          class="
                            text-body
                            fw-medium
                            py-1
                            d-flex
                            align-items-center
                          "
                          data-toggle="collapse"
                          v-b-toggle="'CollapseAltTablo' + TableDataVerileri.Id"
                          role="button"
                          aria-expanded="false"
                          aria-controls="categories-collapse"
                        >
                          <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                        </a>
                      </th>
                      <td>{{ TableDataVerileri.UstDonemAciklama }}</td>
                      <td>{{ TableDataVerileri.StandartKodNo }}</td>
                      <td>{{ TableDataVerileri.StandartGenelSarti }}</td>
                      <td>{{ TableDataVerileri.Kod }}</td>
                      <td>{{ TableDataVerileri.Eylem }}</td>
                       <td style="width: 85px; text-align: center; vertical-align: middle;">
                        <b-button-group>
                          <b-button variant="primary" @click="IsBirlikciAddEdit('Add', TableDataVerileri.Id)"><i class="fa fa-plus"></i></b-button>
                        </b-button-group>
                        
                      </td>
                    </tr>
                    <tr>
                      <td colspan="7">
                        <b-collapse class="collapse show" :id="'CollapseAltTablo' + TableDataVerileri.Id">
                          <IsBirlikciler style="background: rgb(232, 242, 255);" :TanimId="TableDataVerileri.Id" @Id="IsBirlikciAddEdit('Edit', $event)" />
                        </b-collapse>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" :TanimId="TanimId" />
    </Layout>
  </Loader>
</template>
